import React, { useState } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { User, Clock, Plus, Trash2, Loader2 } from 'lucide-react';
import { Badge } from '../../../../components/ui/Badge';
import { workOrdersService } from '../../services/workOrdersService';
import { useEmployees } from '../../../personas/empleados/hooks/useEmployees';

export const ExecutionTeam = ({ workOrder, dateFormat }) => {
  const isFetching = useIsFetching({ queryKey: ['wo'] });
  const workOrderId = workOrder?.id;
  const assignments = workOrder?.assignments || [];
  const assignments_external = workOrder?.assignments_external || [];

  if (!workOrderId) return null;
  if (isFetching > 0)
    return (
      <Loader2 className="animate-spin w-5 h-5 text-blue-400" />
    );

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-white flex items-center gap-2">
          <User className="w-5 h-5 text-gray-400" />
          Team
          <Badge className="bg-gray-700 text-gray-300">
            {assignments.length + assignments_external.length} {assignments.length + assignments_external.length === 1 ? 'member' : 'members'}
          </Badge>
        </h3>
      </div>

      {/* Assignment list - read only */}
      <div className="space-y-3">
        {assignments.map((ass) => (
          <div key={ass.id} className="bg-gray-700/30 rounded-lg border border-gray-600 p-4">
            <div className="flex items-center justify-between flex-wrap gap-2">
              <div>
                <p className="text-white font-medium">{ass.employee_name}</p>
                {ass.role && <p className="text-sm text-gray-400">Role: {ass.role}</p>}
              </div>
            </div>
            {ass.hours_worked > 0 && (
              <div className="mt-2 text-sm text-gray-300">
                <Clock className="w-3 h-3 inline mr-1" />
                {ass.hours_worked} hours worked
              </div>
            )}
            {(ass.start_time || ass.end_time) && (
              <div className="mt-2 text-xs text-gray-500">
                {ass.start_time && <span>Started: {dateFormat(ass.start_time)}</span>}
                {ass.end_time && <span className="ml-3">Ended: {dateFormat(ass.end_time)}</span>}
              </div>
            )}
          </div>
        ))}
        {assignments_external.map((ass) => (
          <div key={ass.id} className="bg-gray-700/30 rounded-lg border border-gray-600 p-4">
            <div className="flex items-center justify-between flex-wrap gap-2">
              <div>
                <p className="text-white font-medium">{ass.employee_name}<span className="ml-2"><Badge className="text-xs h-4 w-auto pb-[5px] relative font-normal bg-blue-900/20 border border-blue-300 text-blue-200">{ass.company_name}</Badge></span></p>
                {ass.role && <p className="text-sm text-gray-400">Role: {ass.role}</p>}
              </div>
            </div>
            {ass.hours_worked > 0 && (
              <div className="mt-2 text-sm text-gray-300">
                <Clock className="w-3 h-3 inline mr-1" />
                {ass.hours_worked} hours worked
              </div>
            )}
            {(ass.start_time || ass.end_time) && (
              <div className="mt-2 text-xs text-gray-500">
                {ass.start_time && <span>Started: {dateFormat(ass.start_time)}</span>}
                {ass.end_time && <span className="ml-3">Ended: {dateFormat(ass.end_time)}</span>}
              </div>
            )}
          </div>
        ))}
        {assignments.length === 0 && assignments_external.length === 0 && (
          <div className="text-center py-8 text-gray-400">
            <User className="w-12 h-12 mx-auto mb-3 opacity-50" />
            <p>No members yet</p>
          </div>
        )}
      </div>
    </div>
  );
};